export const ATM_TYPES = [
  { value: 'ATM_CASH', label: 'ATM Cash' },
  { value: 'ATM_FROM_PROFIT', label: 'ATM From Profit' },
  { value: 'ATM_DIDNT_USE', label: 'ATM Didn’t Use' },
  { value: 'ATM_ADV', label: 'ATM Adv' },
];

// Weekly-report PDF palette — navy + indigo design system, matching the
// on-screen "Totals by Machine Type" card. Keys are kept stable so every
// existing generator reference (C.BLUE_HEADER, C.DARK_NAVY, …) keeps working;
// only the RGB values were re-tuned to the new look.
export const PDF_COLORS = {
  // Core brand
  NAVY:         [10, 14, 42],    // #0a0e2a — headers, table heads, totals
  NAVY_ALT:     [20, 26, 61],    // #141a3d — emphasized total cells
  INDIGO:       [74, 79, 186],   // #4a4fba — accents, section rules
  BORDER:       [229, 231, 242], // #e5e7f2 — hairlines / dividers

  BLUE_HEADER:  [10, 14, 42],    // page header band + table heads → navy
  BLUE_SECTION: [74, 79, 186],   // section titles → indigo
  GREEN_IN:     [15, 138, 95],   // #0f8a5f
  RED_OUT:      [200, 68, 60],   // #c8443c
  ORANGE_EXP:   [217, 119, 6],   // #d97706
  PURPLE_PCT:   [109, 90, 207],  // #6d5acf
  TEAL_CUST:    [15, 138, 138],  // #0f8a8a
  DARK_TEXT:    [10, 14, 42],    // navy body text / headings
  GRAY_TEXT:    [107, 114, 128], // #6b7280
  LIGHT_BG:     [246, 247, 251], // #f6f7fb — zebra rows
  WHITE:        [255, 255, 255],
  BALANCE_BG:   [239, 240, 251], // light indigo tint
  DARK_NAVY:    [10, 14, 42],    // net-profit card → navy
};